<template>
	<div class="emergency">
		<!-- Tab content area -->
        <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3">
        <div class="c-user-tab-content clearfix o-skillset-area">
            <div class="col-md-6 table-td-border-right">

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">Contact Name:</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(emergency_contact) ? emergency_contact.contact_name:""}}</p>
                    </div>
                </div>

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">Contact Number:</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(emergency_contact) ?emergency_contact.contact_number:""}}</p>
                    </div>
                </div>

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">Medical Conditions:</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(emergency_contact) ?emergency_contact.medical_conditions_note:""}}</p>
                    </div>
                </div>

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                       <h4 class="h4">Regular Medications:</h4>
                    </div>
                    <div class="col-md-7">
                       <p class="h5-v1">{{(emergency_contact) ?emergency_contact.regular_medications:""}}</p>
                    </div>
                </div>

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                       <h4 class="h4">Home:</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(emergency_contact) ?emergency_contact.home_phone_no:""}}</p>
                    </div>
                </div>

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                       <h4 class="h4">Cell:</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(emergency_contact) ?emergency_contact.cell_phone_no:""}}</p>
                    </div>
                </div>

                <!-- <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                       <h4 class="h4">Email:</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(emergency_contact) ?emergency_contact.email:""}}</p>
                    </div>
                </div> -->
            </div>
            
        </div>
    </div>

    <!-- <div class="c-common-space c-responsive-fixwidth">
        <a @click="addBatchNotify(userProfile.id)" class="c-common-btn c-common-btn--inverse-icon-orange"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Notify</a>
    </div> -->
        <!-- /Tab content area -->
        <modal name="batch-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
             <div class="modal-add-newJob" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center o-small-modal-head">
                            <button @click="closeBatchNotify()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">Notify</h4>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                            <div class="row">
                                <div class="col-sm-12">
                                  <ul class="o-modal-tab">
                                      <li v-if="getNotificationType=='email'"><a href="javascript: void(0)" @click="notifyEmailTab()" :class="(notifyTab == 'email')?'o-tab-active':''">Email</a></li>
                                      <li v-if="getNotificationType=='sms'"><a href="javascript: void(0)" @click="notifySmsTab()" :class="(notifyTab == 'sms')?'o-tab-active':''">SMS</a></li>
                                  </ul>     
                                </div>
                                <div class="col-sm-12" v-if="notifyTab == 'email'">
                                  <div class="form-group o-attachment-sec">
                                   <vue-editor class="" v-model="emailContent"></vue-editor> 
<!--
                                   <div class="common-label-input--modalwidth o-upload-file attachment-btn-wrapper">
                                            <button class="btn o-attachment-icon"><i class="fa fa-paperclip" aria-hidden="true"></i></button> 
                                            <input type="file" name="myfile"> 
                                            <span>No file chosen</span>
                                        </div>
-->
                                    </div>    
                                </div>
                                <div class="col-sm-12" v-if="notifyTab == 'sms'">
                                  <div class="o-sms-counter o-sms-counter-normal">{{smsContent.length}}/160</div>
                                   <textarea maxlength="160" v-model="smsContent" class="form-control o-no-radius notifySms-field" rows="10" placeholder="Type your SMS"></textarea>  
                                </div>
                            </div>
                        
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeBatchNotify()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="sendNotify()" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Send</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
       </modal>
	</div>
</template>


<script>
    import {
        mapGetters
    } from 'vuex';
    import {
        VueEditor
    } from 'vue2-editor';
    import {
        global
    } from '../../global.js';
    import service from '../../services.js';
    export default {
        components: {
            VueEditor
        },
        computed: {
            ...mapGetters({
                currentEmployeeDetails: 'currentEmployeeDetails',
                userClientID: 'userClientID',
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                getNotificationType: 'getNotificationType',
            })
        },
        data() {
            return {
                emergency_contact: {},
                emailContent: '',
                smsContent: '',
                notifyTab: 'email',
                selectedEmpId: [],
            }
        },
        props: {
            userProfile: {
                type: Object,
                required: true
            }
        },
        watch: {
            userProfile: function(newData) {
                //console.log(newData);
                this.emergency_contact = (newData.emergency_contact.length > 0) ? newData.emergency_contact[0] : {};
            }
        },
        beforeMount() {
            this.emergency_contact = (this.userProfile.emergency_contact.length > 0) ? this.userProfile.emergency_contact[0] : {};
            //console.log("data", this.userProfile.id);
            this.selectedEmpId.push(this.userProfile.id);
            this.notifyTab=this.getNotificationType;
        },
        methods: {
            sendNotify() {
                let formData = {};
                if (this.notifyTab == 'email') {
                    formData = {
                        email: this.emailContent,
                        client_id: this.userClientID,
                        employee_ids: JSON.stringify(this.selectedEmpId)
                    };
                    //console.log(formData);
                } else {
                    formData = {
                        sms: this.smsContent,
                        client_id: this.userClientID,
                        employee_ids: JSON.stringify(this.selectedEmpId)
                    };
                    //console.log(formData);
                }
                service.post('employee/notifyEmployee', formData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Notify Successfully.',
                            type: 'success'
                        });
                        this.$modal.hide('batch-notify');
                    }).catch((err) => {
                        console.log(err);

                    });
            },
            notifyEmailTab() {
                this.notifyTab = 'email';
            },
            notifySmsTab() {
                this.notifyTab = 'sms';
            },
            addBatchNotify(employeeId) {
                this.selectedEmpId = [];
                this.selectedEmpId.push(employeeId);
                this.emailContent = "";
                this.smsContent = "";
                this.$modal.show('batch-notify');
            },
            closeBatchNotify() {
                this.$modal.hide('batch-notify');
            },
            capitaliseFirst(str) {
                var lower = str.toLowerCase();
                return lower.replace(/(^| )(\w)/g, function(x) {
                    return x.toUpperCase();
                });
            },
        }
    }

</script>
<style scoped>


</style>
